import React from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from '../../shared/components/Table';
import { CheckValue } from '../../services/types/Misc';
import CheckBox from '../../shared/components/CheckBox';

interface Props<T> {
  cells: Cell<T>[];
  hideColumns: string[];
  removeColums: string[];
  setHideColumn: (id: string, value: boolean) => void;
  showSelectAll?: boolean;
  onSelectAll?: (columnIds: string[], selectAll: boolean) => void;
}

const ColumnChecks = <T,>(props: Props<T>) => {
  const { cells, hideColumns, removeColums, setHideColumn, showSelectAll, onSelectAll } = props;
  const { t } = useTranslation();
  const columns = cells
    .filter((x) => !x.dependsOn && removeColums.indexOf(x.name || '') < 0)
    .map((c) => ({
      id: c.name || 'id',
      text: t(c.alternativeText || c.column || c.name || ''),
      htmlId: `chk${c.name}`,
      checked: hideColumns.indexOf(c.name || '') === -1,
    }));

  const columnIds = columns.map((c) => c.id);
  const allSelected = columns.every((c) => c.checked);

  const handleSelectAll = (_id: string, value: boolean) => {
    if (onSelectAll) {
      onSelectAll(columnIds, value);
    }
  };

  const selectAllElement: CheckValue = {
    id: 'selectAll',
    text: t('selectAll'),
    htmlId: 'chkSelectAll',
    checked: allSelected,
  };

  const columnCheck = (element: CheckValue) => (
    <CheckBox key={element.id} element={element} onChange={setHideColumn} />
  );

  return (
    <div className="cols-container">
      {showSelectAll && (
        <CheckBox key="selectAll" element={selectAllElement} onChange={handleSelectAll} />
      )}
      {columns.map((c) => columnCheck(c))}
    </div>
  );
};

export default ColumnChecks;
